import React, { useState } from "react";
import Select from "react-select";

const DropdownSearch = ({ selectProps, error = false, label = null }) => (
  <div className="sim-select">
    {label && <label>{label}</label>}
    <Select
      className="single-select"
      classNamePrefix="react-select"
      menuPlacement="auto"
      maxMenuHeight={200}
      menuPosition={"fixed"}
      theme={(theme) => ({
        ...theme,
        borderRadius: 5,
        colors: {
          ...theme.colors,
          primary50: "#ca373c50",
          primary25: "#ca373c50",
          primary: "#ca373c70",
          danger: "#000000",
          neutral30: "#00000050",
        },
      })}
      {...selectProps}
    />
    <p className="error-here">{error ? error : ""}</p>
  </div>
);

export default DropdownSearch;
